import {
  createQueryParameterContext,
  QueryParameterSchema as BaseQueryParameterSchema,
  QueryParametersKey,
  QueryParametersValue,
} from '~/lib/useQueryParameter';
import { StaticProps, useStaticProps } from './StaticPropsContext';
import { schema, Parameters } from '../schema';

// Define the shape of the search query that gets sent to the API
export type GradeConversionSearchQuery = {
  'page[number]'?: number;
  'page[size]'?: number;
  sort?: string;
};

export const queryParameterContext = createQueryParameterContext<StaticProps, GradeConversionSearchQuery, Parameters>(
  schema
);

export type QueryParameterSchema<
  Key extends QueryParametersKey<Parameters>,
  Value = QueryParametersValue<Parameters, Key>,
> = BaseQueryParameterSchema<StaticProps, GradeConversionSearchQuery, Parameters, Key, Value>;

export function QueryParameterContext(props: { children: React.ReactNode }) {
  const staticProps = useStaticProps();
  return (
    <queryParameterContext.Provider defaultParameters={staticProps.defaultParameters} staticProps={staticProps}>
      {props.children}
    </queryParameterContext.Provider>
  );
}
